import { cn } from "@/lib/utils";
import { TONE_TEXT, trsTone } from "@/lib/format";

export const KpiTile = ({ label, value, unit, sub, tone, trs, icon: Icon, testId, className }) => {
  const t = tone || (trs != null ? trsTone(trs) : null);
  return (
    <div data-testid={testId} className={cn("panel p-3 flex flex-col gap-1 min-w-0", className)}>
      <div className="flex items-center justify-between">
        <span className="panel-title truncate">{label}</span>
        {Icon && <Icon className="h-3.5 w-3.5 text-muted-foreground/70" />}
      </div>
      <div className="flex items-baseline gap-1">
        <span className={cn("font-mono text-xl sm:text-2xl font-bold tracking-tight leading-none", t ? TONE_TEXT[t] : "text-foreground")}>{value ?? "—"}</span>
        {unit && <span className="text-xs text-muted-foreground font-mono">{unit}</span>}
      </div>
      {sub && <div className="text-[11px] text-muted-foreground truncate">{sub}</div>}
    </div>
  );
};
